import type { BasketItem, Product, Variant } from '@scayle/storefront-nuxt'
import { BasketListingMetadata } from '~/constants'
import { routeList } from '~/utils'
import { useTrackingEvents } from '~/composables/useTrackingEvents'
import { useRouteHelpers } from '~/composables/useRouteHelpers'
import { useGuestCookie } from '~/composables/useGuestCookie'

export function checkoutNavigation() {
  const { localizedNavigateTo } = useRouteHelpers()
  const { trackBeginCheckout } = useTrackingEvents()

  const { guestUserActiveCookie: setGuestUserActive } = useGuestCookie()

  const goToCheckout = async (opts?: {
    tracking?: 'active' | 'inactive'
    basketItems?: BasketItem<Product, Variant>[]
    originLocation?: string
  }) => {
    if (opts?.tracking === 'active' && opts?.basketItems?.length) {
      trackBeginCheckout(
        opts.basketItems,
        BasketListingMetadata.NAME,
        BasketListingMetadata.ID,
        opts.originLocation,
      )
    }
    setGuestUserActive.value = true
    await localizedNavigateTo(routeList.checkout)
  }

  return {
    setGuestUserActive,
    goToCheckout,
  }
}
